import React from "react";

// Compact circular progress ring (white on the dark hero scrim).
export function BudgetRing({ progress, over, size = 72, stroke = 7 }) {
  const clamped = Math.max(0, Math.min(1, progress || 0));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = c * clamped;
  const fill = over ? "#FF6B60" : "#FFFFFF";
  const pct = Math.round((progress || 0) * 100);

  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} data-testid="budget-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(255,255,255,0.22)" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke={fill}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
          style={{ transition: "stroke-dasharray 0.5s ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span
          className="font-mono font-bold text-lg tabular"
          style={{ color: over ? "#FF6B60" : "#FFFFFF" }}
          data-testid="budget-ring-pct"
        >
          {pct}%
        </span>
        <span className="text-[10px] text-white/70 -mt-0.5">used</span>
      </div>
    </div>
  );
}
